import type { RawTab } from '../../types';

import * as shared from './shared';

export const RewardsTab: RawTab = {
  id: shared.id,

  link: shared.link,

  iconSource: require('./icons/fhs-rewards-inactive.png'),
  iconActiveSource: require('./icons/fhs-rewards-active.png'),

  text: shared.text,
};
